/**
 * Sanitizer for the `redirect_to` param used by the register/login flow.
 *
 * Only allow internal path redirects (starts with `/` and is not protocol-
 * relative). Prevents open-redirect abuse via `?redirect_to=https://evil.com`,
 * `?redirect_to=//evil.com`, `?redirect_to=/\evil.com`, etc.
 *
 * Shared between client (`RegisterPageClient`) and server (`/register` page)
 * so there's one trust boundary and no drift between layers.
 */
export const MAX_REDIRECT_LENGTH = 512;

export function sanitizeRedirect(raw: string | null | undefined): string | null {
  if (!raw) return null;
  if (raw.length > MAX_REDIRECT_LENGTH) return null;
  if (!raw.startsWith('/')) return null;
  // Block protocol-relative URLs like "//evil.com"
  if (raw.startsWith('//')) return null;
  // Block backslash paths ("/\evil.com") — some routers normalize `\` to `/`
  // and could escape to an external host.
  if (raw.includes('\\')) return null;
  // Block whitespace / control chars — belt-and-suspenders against header
  // injection and log flooding.
  // eslint-disable-next-line no-control-regex
  if (/[\s\x00-\x1f]/.test(raw)) return null;
  return raw;
}
